var _this;
const setThis = (_self) => {
  _this = _self;
}

const changeLimit = (limit) => {
    _this.pagination.limit = limit;
    _this.getTableData();
}

function changePage(page) {
    _this.pagination.page = page;
    _this.getTableData();
}

export default {
    setThis,
    changeLimit,
    changePage
};
